import { Grid, withStyles } from '@material-ui/core';
import React, { FC } from 'react';

const Container = withStyles({ root: { backgroundColor: '#F0F0F0', padding: '12px 24px' } })(Grid);

export interface FilterContainerProps {
  left?: JSX.Element;
  right?: JSX.Element;
}
export const FilterContainer: FC<FilterContainerProps> = ({ left, right }) => (
  <Container container justify='space-between'>
    <Grid>{left}</Grid>
    <Grid>{right}</Grid>
  </Container>
);
